import React from 'react';
import TourLineEdit from "../../components/TourlineEdit/TourLineEdit";

const EditableTourline: React.FC = () => {
  return (
    <TourLineEdit/>
  )
};

export default EditableTourline;